import { Link } from "react-router-dom";
import ImageControl from "../../common/ImageControl";
import paths from "../../../constants/paths";
import { websiteLink, toSlugUrl } from "../../../helpers/helpers";

export default function FeaturedCompanyBlock({ company }) {
  const {
    color,
    name,
    image,
    featured,
    activeSponsor,
    description,
    stats,
    tags,
    openPositions,
  } = company;
  return (
    <>
      <div
        className="feature_company_block w-100"
        style={{
          backgroundColor: color + "0e",
          borderColor: color + "1a",
        }}
      >
        <div className="ico_blk">
          <div className="icon">
            {image == "" || image == null ? (
              <img
                src={paths.SITE_BASE_URL + "/images/no-image.svg"}
                alt="no image found"
              />
            ) : (
              <ImageControl src={image} folder="companies" isThumb={true} />
            )}
            {/* <img src={icon} alt={name} /> */}
          </div>
          {featured && (
            <div className="badge" style={{ backgroundColor: color }}>
              Featured
            </div>
          )}
        </div>
        <div className="heading h4">
          <Link
            to={websiteLink(
              `/company-details/${company.encoded_id}/${toSlugUrl(name)}`,
            )}
          >
            {name}
          </Link>
          {activeSponsor && activeSponsor}
        </div>
        <p>{description}</p>
        <ul className="mini_list">
          {stats.map((item, index) => (
            <li key={index}>
              <img src={item.icon} alt="" />
              {item.text}
            </li>
          ))}
        </ul>
        <div className="tag_list">
          {tags.map((tag, index) => (
            <button key={index} type="button">
              {tag}
            </button>
          ))}
        </div>
        <div className="btm_blk">
          <Link
            to={websiteLink(`/company-details/${company.encoded_id}/${toSlugUrl(name)}`)}
            style={{ color: color }}
          >
            {openPositions} Verified Jobs
            {/* <img src={paths.SITE_BASE_URL + "/images/icon_arrow.png"} alt="" /> */}
          </Link>
        </div>
      </div>
    </>
  );
}
